// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"631":"7f0521e7","797":"540f7426","888":"7f0521e7"}[chunkId] + ".chunk.css";
};